/**
 * Widget config (production).
 *
 * apiUrl: Public Cloud Function endpoint, called directly from the browser.
 *         Unlike the staging build (which proxies through a WP admin-ajax
 *         PHP handler so a Cloudflare Access service token can be injected
 *         server-side), the prod CF is publicly reachable — no service
 *         token, no PHP middleman. The CF must therefore allow CORS for
 *         the elementor.com origin and rely on Cloudflare WAF + rate
 *         limiting for abuse protection.
 *
 * FEATURES.feedback: thumbs up/down UI is kept in the code but hidden until
 *                    the feedback endpoint is built. Flip to true once wired.
 *
 * LIMITS: mirrors the Cloud Function's server-side limits so the UI can
 *         short-circuit clearly instead of relying on a 400 response.
 */

export const config = {
  apiUrl: 'https://ask-ai.elementor.com/help-center-ask',
  feedbackUrl: 'https://ask-ai.elementor.com/help-center-feedback',
};

export const FEATURES = {
  feedback: true,
};

export const LIMITS = {
  maxQuestionLength: 500,
  requestTimeoutMs: 15000,
};
